import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { useAuth } from '../../../contexts/AuthContext';

const KioskHeader = ({ 
  showAdminAccess = true,
  currentTime,
  className = '',
  compact = false
}) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleAdminAccess = async () => {
    try {
      // Sign out the current user
      await signOut();
      
      // Navigate to login page
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Error during admin access logout:', error);
      // Still navigate to login page even if logout fails
      navigate('/login', { replace: true });
    }
  };

  const formatTime = (date) => {
    return date?.toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  };

  const formatDate = (date) => {
    return date?.toLocaleDateString('de-DE', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <header className={`bg-surface border-b border-border ${className}`}>
      <div className={`flex items-center justify-between ${compact ? 'h-16 px-4' : 'h-20 px-6'}`}>
        {/* Logo and Title */}
        <div className="flex items-center space-x-4">
          <div className={`${compact ? 'w-10 h-10' : 'w-12 h-12'} bg-primary rounded-xl flex items-center justify-center`}>
            <Icon name="Clock" size={compact ? 20 : 24} color="white" />
          </div>
          <div>
            <h1 className={`${compact ? 'text-xl' : 'text-2xl'} font-semibold text-text-primary`}>PresenceControl</h1>
            <p className={`${compact ? 'text-xs' : 'text-sm'} text-text-secondary`}>Mitarbeiterzeiterfassung</p>
          </div>
        </div>

        {/* Current Time Display */}
        <div className="text-center">
          <div className={`${compact ? 'text-2xl' : 'text-3xl'} font-mono font-semibold text-text-primary`}>
            {formatTime(currentTime)}
          </div>
          <div className={`${compact ? 'text-xs' : 'text-sm'} text-text-secondary`}>
            {formatDate(currentTime)}
          </div>
        </div>

        {/* Admin Access */}
        {showAdminAccess && (
          <div className="flex items-center space-x-3">
            <Button
              variant="ghost"
              size="sm"
              onClick={handleAdminAccess}
              iconName="Settings"
              iconPosition="left"
              className="text-text-secondary hover:text-text-primary touch-feedback"
            >
              Admin-Zugang
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};

export default KioskHeader;